import { format } from 'date-fns/format';

type MonthFormat = 'LLL' | 'LLLL';

const getMonthName = (monthIndex: number, formatToken: MonthFormat): string => {
  const date = new Date(2024, monthIndex, 1);

  return format(date, formatToken);
};

export const shortMonthNames = Array.from({ length: 12 }, (_, i) => getMonthName(i, 'LLL'));

export const longMonthNames = Array.from({ length: 12 }, (_, i) => getMonthName(i, 'LLLL'));

export const shortMonthName = (date: Date): string => {
  return shortMonthNames[date.getMonth()];
};

export const longMonthName = (date: Date): string => {
  return longMonthNames[date.getMonth()];
};
